export const FETCH_BUSINESS_UNITS = 'FETCH_BUSINESS_UNITS';
export const FETCH_BUSINESS_UNITS_SUCCESS = 'FETCH_BUSINESS_UNITS_SUCCESS';
export const FETCH_BUSINESS_UNITS_FAILURE = 'FETCH_BUSINESS_UNITS_FAILURE';
export const FETCH_INITIAL_DATA_FOR_BUSINESS_UNIT_MODAL = 'FETCH_INITIAL_DATA_FOR_BUSINESS_UNIT_MODAL';
export const FETCH_INITIAL_DATA_FOR_BUSINESS_UNIT_MODAL_SUCCESS = 'FETCH_INITIAL_DATA_FOR_BUSINESS_UNIT_MODAL_SUCCESS';
export const FETCH_INITIAL_DATA_FOR_BUSINESS_UNIT_MODAL_FAILURE = 'FETCH_INITIAL_DATA_FOR_BUSINESS_UNIT_MODAL_FAILURE';
export const SAVING_BUSINESS_UNIT_SUCCESS = 'SAVING_BUSINESS_UNIT_SUCCESS';
export const SAVING_BUSINESS_UNIT_FAILURE = 'SAVING_BUSINESS_UNIT_FAILURE';
export const SAVING_BUSINESS_UNIT = 'SAVING_BUSINESS_UNIT';
export const SAVING_BUSINESS_SUCCESS = 'SAVING_BUSINESS_SUCCESS';
export const SAVING_BUSINESS_FAILURE = 'SAVING_BUSINESS_FAILURE';
export const SAVING_BUSINESS = 'SAVING_BUSINESS';
